module.exports = __webpack_public_path__ + "img/back-arrow.30319521.svg";